import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { Video } from '@models/video';
import { PagedResult } from '@models/pagination';
import { PublicApiService } from '@services/publicApiService';

export const defaultVideoKey = 'video';

export const videoKeys = {
    tag: (tags: number[], page: number) => [defaultVideoKey, tags, page],
};

export function useVideosByTags(tags: number[], page: number): UseQueryResult<PagedResult<Video>> {
    return useQuery({
        queryKey: videoKeys.tag(tags, page),
        queryFn: () => PublicApiService.videoPublicService.getVideosByTagId(tags, page),
        enabled: tags.length > 0,
    });
}
